// Dopo un deploy i file della pagina cambiano nome: una scheda rimasta aperta trova 404 sui moduli
// caricati al volo. Si ricarica una sola volta (a distanza di un minuto) per prendere la versione nuova.
const KEY = 'chunk-reload-at'

export function isStaleChunkError(e: unknown): boolean {
  const msg = e instanceof Error ? e.message : String(e ?? '')
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(msg)
}

export function reloadOnceForNewDeploy(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0)
    if (Date.now() - last < 60_000) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    // senza sessionStorage si ricarica comunque: al peggio un solo giro in piu'
  }
  window.location.reload()
  return true
}

export function installStaleDeployGuard() {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnceForNewDeploy()
  })
}
